export default "__VITE_ASSET__BMLmo8AA__"